export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-primary-500">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-3 justify-center lg:justify-start">
              <div className="w-8 h-8 rounded-lg bg-background-50/20 flex items-center justify-center">
                <i className="ri-mail-send-line text-background-50 text-lg"></i>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">投稿爆料</h2>
            </div>
            <p className="text-background-50/80 text-sm md:text-base leading-relaxed mb-6 max-w-[500px] mx-auto lg:mx-0">
              你有独家吃瓜素材？发现遗漏的热门黑料？欢迎向我们投稿爆料。
              我们会对每条投稿认真核实，优质内容将获得首页推荐展示。
              51吃瓜、91吃瓜、黑料吃瓜——你的每一次爆料，都让吃瓜圈更精彩。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 text-background-50/90 text-sm">
                <i className="ri-mail-line text-lg"></i>
                <span>tougao@chigua.news</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/90 text-sm">
                <i className="ri-wechat-line text-lg"></i>
                <span>吃瓜视频客服</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[440px]">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-6 border border-background-50/10">
              <div className="text-background-50 font-semibold text-sm mb-4 flex items-center gap-2">
                <i className="ri-information-line"></i>
                投稿须知
              </div>
              <ul className="space-y-3">
                {[
                  '请确保投稿内容真实可靠，虚假信息将被过滤',
                  '视频素材请提供原始链接或文件',
                  '涉及个人隐私的内容请做脱敏处理',
                  '审核通过后24小时内上线展示',
                  '优质爆料投稿作者可获得专属标识',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2 text-background-50/75 text-xs md:text-sm">
                    <span className="w-5 h-5 rounded-full bg-background-50/20 flex items-center justify-center shrink-0 mt-0.5">
                      <span className="text-[10px] font-bold text-background-50">{i + 1}</span>
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}